/**
 * Notifications whose notes row carries no action are routed from source_type / source_id (ACCESS_REVIEW started this).
 * GM-6538: the logistics hop bells — LOGISTICS_HOP (source_id = invoice id) opens that invoice's logistics page;
 * LOGISTICS_HOPS (a digest, no id) opens the Hops board. Returns a portal path, or null when the item is not ours.
 */
export const normSourceType = (t) =>
    String(t || "")
        .toUpperCase()
        .replace(/-/g, "_");

export const logisticsNotificationPath = (item = {}) => {
    const type = normSourceType(item.source_type);
    const id = item.source_id === null || item.source_id === undefined ? "" : String(item.source_id).trim();
    if (type === "LOGISTICS_HOP" && /^\d+$/.test(id)) return `/logistics-invoice-detail/${id}`;
    if (type === "LOGISTICS_HOPS" || (type === "LOGISTICS_HOP" && !id)) return "/logistics/hops";
    return null;
};
